import ShopMapGoogle from './../classes/ShopsMapGoogle';
import ShopMap from './../classes/ShopsMap';

// const shopMap = new ShopMap();
const shopMap = new ShopMapGoogle();
shopMap.init();
